import { IIconProps } from '../../typescript/interfaces/common.interface';

export default function DotIcon({ fill, ...others }: IIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width='40'
      height='40'
      x='0'
      y='0'
      viewBox='0 0 29.107 29.107'
      xmlSpace='preserve'
      {...others}>
      <g>
        <path
          d='M14.554 0C6.561 0 0 6.562 0 14.552c0 7.996 6.561 14.555 14.554 14.555 7.996 0 14.553-6.559 14.553-14.555C29.106 6.562 22.55 0 14.554 0z'
          fill={fill ?? '#FA9418'}
          opacity='1'
          data-original={fill ?? '#FA9418'}></path>
      </g>
    </svg>
  );
}
